import { render, staticRenderFns } from "./BodyLastDocuments.vue?vue&type=template&id=910ac3a0&scoped=true"
import script from "./BodyLastDocuments.vue?vue&type=script&lang=js"
export * from "./BodyLastDocuments.vue?vue&type=script&lang=js"
import style0 from "./BodyLastDocuments.vue?vue&type=style&index=0&id=910ac3a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910ac3a0",
  null
  
)

export default component.exports